import { OmniElement, html, css } from 'omni-ui';

export class CampaignAudienceSegmentGrouping extends OmniElement {
  static get styles() {
    return css`
      :host {
        position: absolute;
        top: 100%;
        right: 5.74rem;
        z-index: 6;
      }
      omni-tile {
        width: 25.7rem;
      }
      omni-tile::part(body-slot) {
        margin: 1.14rem 1.71rem 1.71rem 1.71rem;
      }
      omni-toolbar {
        height: 3.14286rem;
        padding: 0.42857rem 0.85714rem 0.42857rem 1.14286rem;
      }
      .grouping-container {
        display: flex;
        flex-flow: column nowrap;
        gap: 2.86rem;
      }
      .input-container p {
        color: var(--color-almost-black);
        font-size: 0.78571rem;
        line-height: 1.07143rem;
        letter-spacing: 0.00186rem;
        margin: 0 0 0.57rem 0.5rem;
      }
      .button-container {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        gap: 0.71rem;
      }
    `;
  }

  constructor() {
    super();
    this.name = '';
  }

  render() {
    return html`
      <omni-style>
        <omni-tile>
          <omni-toolbar slot="header">
            <h3 slot="start" class="title is-4 has-text-weight-normal">
              Group Segments
            </h3>
          </omni-toolbar>
          <div class="grouping-container">
            <div class="input-container">
              <p>Audience group name</p>
              <input
                class="input"
                placeholder="Enter name"
                @input="${e => {
                  this.name = e.target.value;
                }}"
              />
            </div>
            <div class="button-container">
              <button
                class="button is-text"
                @click="${() => this.dispatchNewEvent('close-group-segments')}"
              >
                Cancel
              </button>
              <button
                class="button is-primary"
                @click="${() =>
                  this.dispatchNewEvent('name-group-segments', {
                    detail: { name: this.name },
                  })}"
              >
                Add
              </button>
            </div>
          </div>
        </omni-tile>
      </omni-style>
    `;
  }
}

OmniElement.register(
  'campaign-audience-segment-grouping',
  CampaignAudienceSegmentGrouping,
);
